import { getCampaign } from '@app/services/campaigns';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';

export const useCampaignViewPage = () => {
  const navigate = useNavigate();
  const param = useParams();
  const {
    data: campaignData,
    isLoading,
  } = useQuery({
    queryKey: [`campaign-${param.id}`],
    queryFn: () => getCampaign(param?.id as string),
    enabled: !!param.id,
  });

  return {
    navigate,
    campaignData,
    isLoading,
  };
}; 